import { actions } from "store/voice";
import {
  voicesListThunk,
  privateVoicesCheckThunk,
  setFavoriteVoiceThunk,
  updateVoiceSettingsThunk,
  searchVoicesThunk,
  voicesInitialSearchListThunk,
  voicesByIdsThunk,
  accentInfosThunk,
  demoSetsThunk,
  getNarrationStyleTagsThunk,
  getNarrationStyleTagGroupsThunk,
} from "thunks/voice";

import { notificationDisplay } from "./notification";
import { logger } from "utils/logger";

export const {
  voicesListSetPaginationData,
  setSelectedVoice,
  addToConversionVoices,
  removeFromConversionVoices,
  clearConversionVoices,
  setSearchResults,
  addToLastUsed,
  clearLastUsed,
} = actions;

export const voicesList = (payload) => async (dispatch) => {
  try {
    await dispatch(voicesListThunk(payload));
  } catch (error) {
    logger.trace(error);
  }
};

export const privateVoicesCheck = (payload) => async (dispatch) => {
  try {
    await dispatch(privateVoicesCheckThunk(payload));
  } catch (error) {
    logger.trace(error);
  }
};

export const setFavoriteVoice = (payload) => async (dispatch) => {
  try {
    await dispatch(setFavoriteVoiceThunk(payload));
  } catch (error) {
    logger.trace(error);
  }
};

export const updateVoiceSettings = (payload) => async (dispatch) => {
  try {
    await dispatch(updateVoiceSettingsThunk(payload)).unwrap();
  } catch (error) {
    dispatch(notificationDisplay("error", error));
    logger.trace(error);
  }
};

export const voicesInitialSearchList = (payload) => async (dispatch) => {
  try {
    await dispatch(voicesInitialSearchListThunk(payload)).unwrap();
  } catch (error) {
    logger.trace(error);
  }
};

export const searchVoices = (payload) => async (dispatch) => {
  try {
    await dispatch(searchVoicesThunk(payload)).unwrap();
  } catch (error) {
    logger.trace(error);
  }
};

export const voicesByIds = (payload) => async (dispatch) => {
  try {
    await dispatch(voicesByIdsThunk(payload)).unwrap();
  } catch (error) {
    logger.trace(error);
  }
};

export const accentInfos = (payload) => async (dispatch) => {
  try {
    await dispatch(accentInfosThunk(payload)).unwrap();
  } catch (error) {
    logger.trace(error);
  }
};

export const demoSets = (payload) => async (dispatch) => {
  try {
    await dispatch(demoSetsThunk(payload)).unwrap();
  } catch (error) {
    logger.trace(error);
  }
};

export const getNarrationStyleTags = (payload) => async (dispatch) => {
  try {
    await dispatch(getNarrationStyleTagsThunk(payload)).unwrap();
  } catch (error) {
    logger.trace(error);
  }
};

export const getNarrationStyleTagGroups = (payload) => async (dispatch) => {
  try {
    await dispatch(getNarrationStyleTagGroupsThunk(payload)).unwrap();
  } catch (error) {
    logger.trace(error);
  }
};
